import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { PaymentService } from '@core/services/PaymentService';

// const fake = {
//   meta: { total: 2, items_per_page: 10, current_page: 1, total_pages: 1 },
//   data: [
//     {
//       created_at: '2022-07-14 15:47:20',
//       state: 'new',
//       amount: '-750.000000',
//       system: '',
//       type: 'a_number_subscription_fee',
//       data: {
//         number: '89188519942'
//       }
//     },
//     {
//       created_at: '2022-07-14 15:47:20',
//       state: 'success',
//       amount: '-750.000000',
//       system: 'yoomoney',
//       type: 'a_number_connection_cost',
//       data: {
//         number: '89188519942'
//       }
//     },
//     {
//       created_at: '2022-07-14 15:47:20',
//       state: 'failed',
//       amount: '-750.000000',
//       system: 'yoomoney',
//       type: 'referral_reward'
//     },
//     {
//       created_at: '2022-07-14 15:47:20',
//       state: 'frozen',
//       amount: '-750.000000',
//       system: 'yoomoney',
//       type: 'pbx'
//     },
//     {
//       created_at: '2022-07-14 15:47:20',
//       state: 'success',
//       amount: '-750.000000',
//       system: 'yoomoney',
//       type: 'pbx',
//       data: {
//         service_package_name: 'Package Name'
//       }
//     },
//     {
//       created_at: '2022-07-14 15:47:20',
//       state: 'success',
//       amount: '-750.000000',
//       system: null,
//       type: 'write-off'
//     },
//     {
//       created_at: '2022-07-14 15:47:20',
//       state: 'success',
//       amount: '-750.000000',
//       system: 'yoomoney',
//       type: 'balance refill'
//     },
//     {
//       created_at: '2022-07-14 15:39:02',
//       state: 'success',
//       amount: '750.000000',
//       type: 'balance refill',
//       system: 'internal'
//     }
//   ]
// };

const verification_types = [
  'sms_number_verification',
  'voice_number_verification',
  'phone_number_verification',
  'call_number_verification'
];

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => {
        return PaymentService.getList(params).then((res) => {
          return {
            ...res,
            data: res.data.map((item) => ({
              ...item,
              system: verification_types.find((type) => type === item.type) ? 'zorra' : item.system
            }))
          };
        });
      }
    }
  },
  true
);
